export default "__VITE_PUBLIC_ASSET__1f29d553__"